import {
  SystemClassifierCode,
  SystemClassifierItemDto,
} from '../systemClassifier';
import { useSystemClassifiers } from './useSystemClassifiers';

export const useSystemClassifierItems = (
  code: SystemClassifierCode,
  itemCodes?: string[]
): SystemClassifierItemDto[] => {
  const allItems =
    useSystemClassifiers(code)[code]?.systemClassifierItems || [];

  if (itemCodes?.length) {
    const itemsByOrderOfCodes: SystemClassifierItemDto[] = [];

    allItems.forEach((item) => {
      const index = itemCodes.indexOf(item.code);
      if (index !== -1) {
        itemsByOrderOfCodes[index] = item;
      }
    });

    return itemsByOrderOfCodes;
  }

  return allItems;
};
